import angular from 'angular';

let fastSearchModule = angular.module('app.catalog.fastSearch', []);

export default fastSearchModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/fast-search/fast-search.js
 **/